import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Box } from '../Box/Box';
import { ShimmerVariationType, VARIATION_BACKGROUND_COLORS, VARIATION_GLARE_GRADIENTS } from './constants';
const animation = props => keyframes(["0%{transform:translateX(-200px)}100%{transform:translateX(", "px)}"], props.animationWidth);
const animationRule = /*#__PURE__*/css(["", " 1.2s ease-in-out infinite;"], animation);
const Wrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Shimmer__Wrapper",
  componentId: "sc-3bob20-0"
})(["background-color:", ";background-size:200px 100%;background-repeat:no-repeat;display:inline-block;line-height:1;", " overflow:hidden;"], props => VARIATION_BACKGROUND_COLORS[props.variation], props => props.height && `height: ${props.height};`);
const Glare = /*#__PURE__*/styled.span.withConfig({
  displayName: "Shimmer__Glare",
  componentId: "sc-3bob20-1"
})(["display:inline-block;background-image:linear-gradient(to right,", ");background-image:-webkit-linear-gradient(left,", ");animation:", ";height:100%;width:200px;@media (prefers-reduced-motion){animation:none;}"], props => VARIATION_GLARE_GRADIENTS[props.variation], props => VARIATION_GLARE_GRADIENTS[props.variation], animationRule);
/**
 * @public
 */
export function Shimmer({
  animationWidth = 100,
  disable = false,
  variation = ShimmerVariationType.Base,
  ...props
}) {
  return React.createElement(Wrapper, {
    ...props,
    "data-testid": 'Shimmer__Wrapper',
    variation: variation
  }, !disable && React.createElement(Glare, {
    animationWidth: animationWidth + 200,
    "data-testid": 'Shimmer__Glare',
    variation: variation
  }, "\u200C"));
}